import { useQuery, QueryOptions, UseQueryResult } from '@tanstack/react-query'

import { getSeoCountriesJSON } from '@pepper/utils/src/api/utils/utils'

export function useSEOCountriesJSON(
  config?: QueryOptions<Record<SEOCountries, SEOCountryData>, Error>
): UseQueryResult<Record<SEOCountries, SEOCountryData>, Error> {
  return useQuery({
    queryKey: ['seoCountries'],
    queryFn: async () => {
      const response = await getSeoCountriesJSON()
      if (response.status === 'ok') {
        return response.data?.response
      }
      throw new Error(response.error)
    },
    ...config,
  })
}
